import React, { Component } from 'react'
import styled from 'styled-components'

import logo from '../images/fsc_logo.png'

export default class Header extends Component {
  constructor() {
    super()
    this.state = {
      dropdownOpened: false
    }
  }

  toggleDropdown = () => {
    if (!this.state.dropdownOpened) {
      document.addEventListener('click', this.handleOutsideClick, false)
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false)
    }

    this.setState(prevState => ({
       dropdownOpened: !prevState.dropdownOpened,
    }))
  }

  handleOutsideClick = (e) => {
    this.toggleDropdown()
  }

  render() {
    return (
      <HeaderWrapper>
        <LogoLink href='https://www.firststepcoding.com/'>
          <LogoImage src={logo}/>
        </LogoLink>
        <RightGroupItems>
          <div>
            <MenuItemCourses onClick={this.toggleDropdown}>Courses</MenuItemCourses>
            {
              this.state.dropdownOpened &&
              <DropdownMenu>
                <MenuItem href='https://www.firststepcoding.com/intro-to-coding'>
                  Intro to Coding
                </MenuItem>
                <MenuItem href='https://www.firststepcoding.com/bootcamp-prep'>
                  Bootcamp Prep
                </MenuItem>
                <MenuItem href='https://www.firststepcoding.com/corporate-training'>
                  Corporate Training
                </MenuItem>
              </DropdownMenu>
            }
          </div>
          <MenuItem href='https://www.firststepcoding.com/instructors'>Instructors</MenuItem>
          {/* <MenuItem href='https://www.firststepcoding.com/bootcamp-partners'>Bootcamp partners</MenuItem> */}
          <MenuItem href='https://www.firststepcoding.com/faq'>F.A.Q.</MenuItem>
          {/* <MenuItem href='https://www.firststepcoding.com/social-impact'>Social Impact</MenuItem> */}
          {/* <ApplyButtonWrapper>
            <ApplyButton href='https://www.firststepcoding.com/register'>
              Register
            </ApplyButton>
          </ApplyButtonWrapper> */}
        </RightGroupItems>
      </HeaderWrapper>
    )
  }
}

const LogoLink = styled.a`
  display: flex;
  align-items: center;
  vertical-align: middle;
  padding: 15px 13px;
`

const LogoImage = styled.img`
  width: 200px;
  margin: 0;
`

const RightGroupItems = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`

const HeaderWrapper = styled.div`
  position: sticky;
  top: 0px;
  z-index: 900;
  width: 100%;
  border: 0 solid transparent;
  background: #1a1a1a;
  display: inline-flex;
  margin: 0;
  verticalAlign: middle;
  borderRadius: 0;
  align-items: center;

  @media only screen and (max-width: 975px) {
    display: none;
  }
`

const MenuItem = styled.a`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 15px 13px;
  text-transform: uppercase;
  font-family: raleway;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 20px;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  text-align: center;

  &:hover {
    color: #3d9991;
  }
`

const MenuItemCourses = styled(MenuItem)`
  &:after {
    content: '';
    display: block;
    width: 0; 
    height: 0; 
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid white;
    margin-left: 8px;
  }

  &:hover:after {
    border-top-color: #3d9991;
  }
`

const DropdownMenu = styled.div`
  border-radius: 0 0 .28571429rem .28571429rem;
  margin: 0;
  flex-direction: column;
  position: absolute;
  min-width: max-content;
  padding: 0;
  font-size: 1em;
  text-align: left;
  box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
  border: 1px solid rgba(34,36,38,.15);
  z-index: 11;
  background: #1a1a1a;
`


const ApplyButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 15px 13px;
  position: relative;
`

const ApplyButton = styled.a`
  display: block;
  background-color: #3d9991;
  color: #fff;
  text-decoration: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 12px;
  text-align: center;
  font-family: raleway;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  line-height: initial;
  cursor: pointer;
  box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;

  &:hover {
    background-color: #328b83;
  }
`
